import { apiSlice } from '../../apiSlice';

export const gatewayApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['Gateway'],
    endpoints: builder => ({
        getGatewayConnectionInfo: builder.query({
            query: (args) => {
                const { gatewayId, timestamp } = args
                return {
                    url: `/Gateway/${gatewayId}/ConnectionInfo?orderby=Timestamp&Timestamp=ge(${timestamp})&top=1000`,
                    providesTags: ['Gateway, GatewayConnectionInfo'],
                }
            }
        }),
        getGatewayById: builder.query({
            query: (args) => {
                const gatewayId = args
                return {
                    url: `/Gateway/${gatewayId}`,
                    providesTags: ['Gateway'],
                }
            }
        }),
        getGatewaysByAccount: builder.query({
            query: (args) => {
                const id = args
                return {
                    url: `/Gateway?orderby=GatewayId&Account.AccountId=eq(${id})&top=1000`,
                    providesTags: ['Gateway'],
                }
            }
        }),
    })
})

export const {
    useGetGatewayConnectionInfoQuery,
    useGetGatewayByIdQuery,
    useLazyGetGatewayByIdQuery,
    useGetGatewaysByAccountQuery,
    useLazyGetGatewaysByAccountQuery,
} = gatewayApiSlice